var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.182,
    height: 14.642,
    viewBox: "0 0 15.182 14.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    transform: "translate(0.36 0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-2",
    "data-name": "Icon awesome-star",
    d: "M7.9.484l-1.765,3.6-3.949.579A.872.872,0,0,0,1.7,6.149l2.857,2.8-.676,3.958a.866.866,0,0,0,1.254.917l3.533-1.869,3.533,1.869a.866.866,0,0,0,1.254-.917l-.676-3.958,2.857-2.8a.872.872,0,0,0-.478-1.485l-3.949-.579L9.448.484A.863.863,0,0,0,7.9.484Z",
    transform: "translate(-1.441 0.001)",
    fill: "#4c96ce",
    stroke: "#4c96ce",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavFill);
export default __webpack_public_path__ + "static/media/iconFavFill.dfe4b283e33074986d34277f8ac310ef.svg";
export { ForwardRef as ReactComponent };